export const NAME = 'edit-template-view';
export const SIDE_WIDTH = 140;
